<template>
  <v-card class="mx-auto">
    <v-card-title id="map">
      <MglMap v-if="nets" :mapStyle='mapStyle' :center="coordinates" :zoom="4" :accessToken='accessToken'>
        <MglMarker maxWidth="300px" v-for="net in nets" :coordinates="[net.nodeLongitude, net.nodeLatitude]" :key='net.netId' :color="net.color">
          <MglPopup setWidth="300px" anchor="top" @open="centerMap">
              <net-card :net="net"/>
          </MglPopup>
        </MglMarker>
      </MglMap>
    </v-card-title>
  </v-card>
</template>
<style>
#map {
 width: 100%;
 height: 600px;
 padding:0;
 overflow: hidden;
}
.marker {
  background-size: cover;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
}
.mapboxgl-popup-content {
  width: 300px;
  padding: 0;
  margin: 0;
  background-color: transparent;
  border: none;
  box-shadow: none;
  margin-top: -10px;
}
.mapboxgl-popup-close-button{
  z-index:100;
  padding:1em 1em;
}
.mapbox-improve-map, .mapboxgl-ctrl, .mapboxgl-ctrl-attrib{
    display: none;
}
</style>
<script>
import { MglMap, MglMarker, MglPopup } from 'vue-mapbox'
import NetCard from "../components/NetCard.vue"
import Mapbox from 'mapbox-gl'
export default {
  components: {
    MglMap,
    MglMarker,
    MglPopup,
    NetCard
  },
  props: ['nets'],
  data: () => ({
    isLoading: false,
    selected: [],
    coordinates: [12.5674 ,42.8719],
    accessToken: 'pk.eyJ1IjoibWlya28td2luZXQiLCJhIjoiY2s2aHM3cGF0MDcyNzNlbXN3am53ZHV4MSJ9.6oJVbUa1SwroCHKxgGAGyA',
    mapStyle: 'mapbox://styles/mirko-winet/ck6hsyhvl0vyn1is5a8p5u2hj'
  }),
  created () {
    this.mapbox = Mapbox
  },
  methods: {
    centerMap(p){
      p.map.panTo(p.popup._lngLat)
    }
  }
}
</script>
